import { LinkNode } from '@lexical/link';
import { isHTMLElement } from 'lexical';
import { linkClasses } from '../utils';
export class CustomLinkNode extends LinkNode {
    retainTarget;
    constructor(url, retainTarget, key) {
        super(url, undefined, key);
        this.retainTarget = retainTarget;
    }
    static getType() {
        return 'custom_link';
    }
    static clone(node) {
        if (node instanceof CustomLinkNode) {
            return new CustomLinkNode(node.__url, node.retainTarget, node.getKey());
        }
        return new CustomLinkNode(node.__url, false, node.getKey());
    }
    static importJSON(node) {
        return super.importJSON(node);
    }
    createDOM(config) {
        const dom = super.createDOM(config);
        dom.setAttribute('rel', 'noopener noreferrer');
        dom.setAttribute('target', '_blank');
        dom.setAttribute('class', linkClasses);
        return dom;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: 'custom_link',
            version: 1,
        };
    }
    /**
     * Overrides the exportDOM method to remove additional classes, styles, and attributes from an a tag.
     * @override
     */
    exportDOM(editor) {
        const { element } = super.exportDOM(editor);
        if (element && isHTMLElement(element)) {
            element.removeAttribute('class');
            element.removeAttribute('rel');
            if (!this.retainTarget) {
                element.removeAttribute('target');
            }
        }
        return { element };
    }
}
